import { useMemo } from 'react';
import { isUnder } from '@nsi-advisory-services/components';
import usePermissions from '../../hooks/usePermissions';

// One list for the sidebar and the phone bottom bar, so both agree on the current section.
// `match` owns a whole branch: deep routes such as /projects/4/task-orders/7/tasks/9/actuals
// still belong to Projects.
export default function useNavItems() {
  const { can } = usePermissions();
  return useMemo(
    () => [
      {
        path: '/',
        icon: 'bi-collection',
        label: 'Projects',
        match: (p) => p === '/' || isUnder(p, '/projects') || isUnder(p, '/tasks') || isUnder(p, '/import-hours'),
      },
      { path: '/my-workplan', icon: 'bi-calendar-check', label: 'My Workplan', shortLabel: 'Workplan' },
      can('charts.view') && { path: '/charts', icon: 'bi-bar-chart-line', label: 'Charts' },
      can('wbs.view') && { path: '/wbs-manager', icon: 'bi-diagram-3', label: 'WBS Manager', bottomNav: false },
      {
        path: '/configuration',
        icon: 'bi-gear',
        label: 'Configuration',
        shortLabel: 'Config',
        match: (p) => isUnder(p, '/configuration') || isUnder(p, '/users'),
      },
      { path: '/help', icon: 'bi-question-circle', label: 'Help' },
    ],
    [can]
  );
}
